import { BroadcastChannel } from 'broadcast-channel';

// eslint-disable-next-line import/prefer-default-export
export const channel = new BroadcastChannel(
  'serviceworker-bus',
  process.env.JEST_WORKER_ID !== undefined ? {} : { type: 'native' },
);
